const shippingUrls = {
  "de-de": "https://www.vistaprint.de/lieferung"
};

export { shippingUrls };
//# sourceMappingURL=ep-pricing-esm-constants-shippingUrl.js.map
